<template>
  <Modal v-model="open" :title="title" width="900" :mask-closable="false" @on-cancel="cancel('formItem')">
    <Tabs v-model="activeTab">
      <TabPane label="基本信息" name="basic">
        <Form
          ref="formItem"
          :model="formItem"
          :label-width="80"
          :rules="ruleValidate"
        >
          <FormItem label="区域名称" prop="area_name">
            <Input
              v-model="formItem.area_name"
              placeholder="请输入区域名称"
              clearable
            />
          </FormItem>
          <FormItem label="区域描述" prop="area_desc">
            <Input
              v-model="formItem.area_desc"
              placeholder="请输入区域描述"
              clearable
            />
          </FormItem>
          <FormItem label="客服电话" prop="phone">
            <Input
              v-model="formItem.phone"
              placeholder="请输入客服电话"
              clearable
            />
          </FormItem>
          <FormItem label="中心点地址" prop="centerAddress">
            <div class="address-input-wrapper">
              <Input
                ref="addressInput"
                v-model="centerAddress"
                placeholder="请输入地址关键词，如：北京市朝阳区"
                clearable
                @on-focus="handleAddressFocus"
                @on-blur="handleAddressBlur"
                @on-change="handleAddressChange"
              />
              <!-- 地址下拉列表 -->
              <div 
                v-show="addressSuggestions.length > 0 && showSuggestions" 
                class="address-suggestions"
              >
                <div
                  v-for="(item, index) in addressSuggestions"
                  :key="index"
                  class="suggestion-item"
                  @mousedown.prevent="selectAddress(item)"
                  @mouseenter="hoveredIndex = index"
                  @mouseleave="hoveredIndex = -1"
                  :class="{ 'hovered': hoveredIndex === index }"
                >
                  <Icon type="ios-locate" style="margin-right: 8px; color: #1890ff;" />
                  <div class="suggestion-content">
                    <div class="suggestion-name">{{ item.name || '未知地点' }}</div>
                    <div class="suggestion-address">{{ item.district || '' }}{{ item.address || '' }}</div>
                  </div>
                </div>
              </div>
              <!-- 加载提示 -->
              <div 
                v-if="geocoding && showSuggestions" 
                class="address-suggestions"
                style="padding: 12px; text-align: center; color: #999;"
              >
                <Icon type="ios-loading" class="ivu-load-loop" />
                <span style="margin-left: 8px;">搜索中...</span>
              </div>
              <!-- 无结果提示 -->
              <div 
                v-if="addressSuggestions.length === 0 && showSuggestions && centerAddress && !geocoding" 
                class="address-suggestions"
                style="padding: 12px; text-align: center; color: #999;"
              >
                未找到相关地址
              </div>
            </div>
            <div style="color: #999; font-size: 12px; margin-top: 4px;">
              提示：输入地址关键词，从下拉列表中选择；也可以手动输入经纬度
            </div>
          </FormItem>
          <FormItem label="中心点经度" prop="center">
            <Input
              type="number"
              v-model="formItem.center.coordinates[0]"
              placeholder="请输入经度"
              clearable
              @on-blur="reverseGeocode"
            />
          </FormItem>
          <FormItem label="中心点纬度" prop="center">
            <Input
              type="number"
              v-model="formItem.center.coordinates[1]"
              placeholder="请输入纬度"
              clearable
              @on-blur="reverseGeocode"
            />
          </FormItem>
          <FormItem v-if="locationAddress">
            <div style="color: #52c41a; font-size: 12px;">
              <Icon type="ios-checkmark-circle" />
              当前位置：{{ locationAddress }}
            </div>
          </FormItem>
          <FormItem label="还车点地址" prop="returnPointAddress">
            <div class="address-input-wrapper">
              <Input
                ref="returnPointAddressInput"
                v-model="returnPointAddress"
                placeholder="请输入还车点地址关键词，如：北京市朝阳区"
                clearable
                @on-focus="handleReturnPointAddressFocus"
                @on-blur="handleReturnPointAddressBlur"
                @on-change="handleReturnPointAddressChange"
              />
              <!-- 地址下拉列表 -->
              <div 
                v-show="returnPointAddressSuggestions.length > 0 && showReturnPointSuggestions" 
                class="address-suggestions"
              >
                <div
                  v-for="(item, index) in returnPointAddressSuggestions"
                  :key="index"
                  class="suggestion-item"
                  @mousedown.prevent="selectReturnPointAddress(item)"
                  @mouseenter="returnPointHoveredIndex = index"
                  @mouseleave="returnPointHoveredIndex = -1"
                  :class="{ 'hovered': returnPointHoveredIndex === index }"
                >
                  <Icon type="ios-locate" style="margin-right: 8px; color: #1890ff;" />
                  <div class="suggestion-content">
                    <div class="suggestion-name">{{ item.name || '未知地点' }}</div>
                    <div class="suggestion-address">{{ item.district || '' }}{{ item.address || '' }}</div>
                  </div>
                </div>
              </div>
              <!-- 加载提示 -->
              <div 
                v-if="returnPointGeocoding && showReturnPointSuggestions" 
                class="address-suggestions"
                style="padding: 12px; text-align: center; color: #999;"
              >
                <Icon type="ios-loading" class="ivu-load-loop" />
                <span style="margin-left: 8px;">搜索中...</span>
              </div>
              <!-- 无结果提示 -->
              <div 
                v-if="returnPointAddressSuggestions.length === 0 && showReturnPointSuggestions && returnPointAddress && !returnPointGeocoding" 
                class="address-suggestions"
                style="padding: 12px; text-align: center; color: #999;"
              >
                未找到相关地址
              </div>
            </div>
            <div style="color: #999; font-size: 12px; margin-top: 4px;">
              提示：输入地址关键词，从下拉列表中选择；也可以手动输入经纬度
            </div>
          </FormItem>
          <FormItem label="还车点经度" prop="return_point">
            <Input
              type="number"
              v-model="formItem.return_point.coordinates[0]"
              placeholder="请输入还车点经度"
              clearable
              @on-blur="reverseGeocodeReturnPoint"
            />
          </FormItem>
          <FormItem label="还车点纬度" prop="return_point">
            <Input
              type="number"
              v-model="formItem.return_point.coordinates[1]"
              placeholder="请输入还车点纬度"
              clearable
              @on-blur="reverseGeocodeReturnPoint"
            />
          </FormItem>
          <FormItem v-if="returnPointLocationAddress">
            <div style="color: #52c41a; font-size: 12px;">
              <Icon type="ios-checkmark-circle" />
              还车点位置：{{ returnPointLocationAddress }}
            </div>
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="边界编辑" name="boundary">
        <AreaBoundaryEditor
          v-if="activeTab === 'boundary'"
          ref="boundaryEditor"
          :key="'boundary-editor-' + (formItem.area_id || 'new')"
          :center="getMapCenter()"
          :boundary="formItem.boundary || []"
          @boundary-change="handleBoundaryChange"
        />
      </TabPane>
    </Tabs>
    <div slot="footer" style="text-align: center">
      <Button type="default" @click="cancel('formItem')">关闭</Button>
      <Button type="primary" :loading="loading" @click="ok('formItem')">
        提交
      </Button>
    </div>
  </Modal>
</template>
<script>
import { addArea, editArea, getAreaListByRole } from '@/api/area'
import { searchPlace, geocode, regeocode } from '@/api/geocoder'
import AreaBoundaryEditor from '@/components/AreaBoundaryEditor.vue'

export default {
  name: 'AreaAddUpdate',
  components: {
    AreaBoundaryEditor
  },
  data() {
    return {
      activeTab: 'basic',
      formItem: {
        area_name: '',
        area_desc: '',
        phone: '',
        center: {
          type: 'Point',
          coordinates: ['', ''],
        },
        return_point: {
          type: 'Point',
          coordinates: ['', ''],
        },
        boundary: [], // 边界坐标数组
      },
      // 初始化标志，防止计算属性在数据未初始化时执行
      initialized: false,
      // 地址相关
      centerAddress: '', // 地址输入
      originalBoundary: null, // 保存原始边界数据，用于判断是否需要提示
      locationAddress: '', // 根据经纬度反查的地址
      geocoding: false, // 地理编码中
      addressSuggestions: [], // 地址建议列表
      showSuggestions: false, // 是否显示建议列表
      hoveredIndex: -1, // 当前悬停的索引
      autocomplete: null, // 自动补全实例
      searchTimer: null, // 搜索防抖定时器
      // 还车点地址相关
      returnPointAddress: '', // 还车点地址输入
      returnPointLocationAddress: '', // 根据经纬度反查的还车点地址
      returnPointGeocoding: false, // 还车点地理编码中
      returnPointAddressSuggestions: [], // 还车点地址建议列表
      showReturnPointSuggestions: false, // 是否显示还车点建议列表
      returnPointHoveredIndex: -1, // 当前悬停的还车点索引
      returnPointAutocomplete: null, // 还车点自动补全实例
      returnPointSearchTimer: null, // 还车点搜索防抖定时器
      ruleValidate: {
        area_name: [  // 修改为下划线形式
          { required: true, message: '请输入区域名称', trigger: 'blur' },
        ],
        area_desc: [  // 修改为下划线形式
          { required: true, message: '请输入区域描述', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入客服电话', trigger: 'blur' },
        ],
        center: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const validCoord = (v) => v !== '' && v !== null && v !== undefined && !isNaN(parseFloat(v))
              if (
                !value ||
                !value.coordinates ||
                !Array.isArray(value.coordinates) ||
                value.coordinates.length < 2 ||
                !validCoord(value.coordinates[0]) ||
                !validCoord(value.coordinates[1])
              ) {
                callback(new Error('请输入中心点经纬度，或在边界编辑中自动生成'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        return_point: [
          {
            required: false,
            validator: (rule, value, callback) => {
              const validCoord = (v) => v !== '' && v !== null && v !== undefined && !isNaN(parseFloat(v))
              if (!value || !value.coordinates || !Array.isArray(value.coordinates) || value.coordinates.length < 2) {
                callback()
                return
              }
              if (!validCoord(value.coordinates[0]) || !validCoord(value.coordinates[1])) {
                callback(new Error('请输入有效的还车点经纬度'))
                return
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
      },
      open: false,
      title: '添加区域',
      loading: false,
    }
  },
  methods: {
    // 初始化表单数据的函数，用于添加或修改区域
    init(params) {
      console.log(params) // 在控制台打印传入的参数，用于调试
      this.activeTab = 'basic' // 重置到基本信息标签
      
      if (params) {
        // 如果params存在，表示是修改操作
        this.title = '修改区域'
        this.formItem = JSON.parse(JSON.stringify(params))
        
        // 确保字段名称正确转换
        if (params.areaName !== undefined && !this.formItem.area_name) {
          this.formItem.area_name = params.areaName;
        }
        if (params.areaDesc !== undefined && !this.formItem.area_desc) {
          this.formItem.area_desc = params.areaDesc;
        }
        
        // 处理边界数据
        if (params.boundary) {
          if (params.boundary.coordinates && Array.isArray(params.boundary.coordinates)) {
            // 如果是MongoDB GeoJSON格式，提取坐标
            // Polygon格式: { type: 'Polygon', coordinates: [[[lng, lat], ...]] }
            if (params.boundary.coordinates[0] && Array.isArray(params.boundary.coordinates[0])) {
              this.formItem.boundary = params.boundary.coordinates[0]
              // 保存原始边界数据
              this.originalBoundary = JSON.parse(JSON.stringify(this.formItem.boundary))
              console.log('加载边界数据（GeoJSON格式）:', this.formItem.boundary)
            } else {
              this.formItem.boundary = []
              this.originalBoundary = null
            }
          } else if (Array.isArray(params.boundary)) {
            // 如果是数组格式，直接使用
            this.formItem.boundary = params.boundary
            // 保存原始边界数据
            this.originalBoundary = JSON.parse(JSON.stringify(this.formItem.boundary))
            console.log('加载边界数据（数组格式）:', this.formItem.boundary)
          } else {
            this.formItem.boundary = []
            this.originalBoundary = null
          }
        } else {
          this.formItem.boundary = []
          this.originalBoundary = null
        }
        
        // 处理中心点
        if (params.center && params.center.coordinates) {
          this.formItem.center = {
            type: 'Point',
            coordinates: params.center.coordinates
          }
          // 如果有经纬度，反查地址并显示
          if (params.center.coordinates[0] && params.center.coordinates[1]) {
            this.loadAddressFromCoordinates(params.center.coordinates)
          }
        } else if (params.location && params.location.coordinates) {
          // 兼容旧的location字段
          this.formItem.center = {
            type: 'Point',
            coordinates: params.location.coordinates
          }
          // 如果有经纬度，反查地址并显示
          if (params.location.coordinates[0] && params.location.coordinates[1]) {
            this.loadAddressFromCoordinates(params.location.coordinates)
          }
        } else if (!this.formItem.center || !this.formItem.center.coordinates) {
          this.formItem.center = {
            type: 'Point',
            coordinates: ['', '']
          }
        }
        
        // 处理还车点
        if (params.return_point && params.return_point.coordinates) {
          this.formItem.return_point = {
            type: 'Point',
            coordinates: params.return_point.coordinates
          }
          // 如果有经纬度，反查地址并显示
          if (params.return_point.coordinates[0] && params.return_point.coordinates[1]) {
            this.loadReturnPointAddressFromCoordinates(params.return_point.coordinates)
          }
        } else if (!this.formItem.return_point || !this.formItem.return_point.coordinates) {
          this.formItem.return_point = {
            type: 'Point',
            coordinates: ['', '']
          }
        }
        
        // 重置地址建议列表
        this.addressSuggestions = []
        this.showSuggestions = false
        // 重置还车点地址建议列表
        this.returnPointAddressSuggestions = []
        this.showReturnPointSuggestions = false
      } else {
        // 如果params不存在，表示是添加操作
        this.title = '添加区域'
        this.formItem = {
          area_name: '',
          area_desc: '',
          phone: '',
          center: {
            type: 'Point',
            coordinates: ['', ''],
          },
          return_point: {
            type: 'Point',
            coordinates: ['', ''],
          },
          boundary: [],
        }
      }
      this.initialized = true
      this.open = true
      
      // 初始化地址自动补全
      this.$nextTick(() => {
        this.initAutocomplete()
      })
    },
    
    // 处理边界变化
    handleBoundaryChange(boundary) {
      this.formItem.boundary = boundary
      
      // 如果有边界，自动计算中心点
      if (boundary && boundary.length > 0) {
        // 排除闭合点
        const points = boundary.slice(0, -1)
        if (points.length > 0) {
          const lngs = points.map(p => p[0])
          const lats = points.map(p => p[1])
          const centerLng = (Math.min(...lngs) + Math.max(...lngs)) / 2
          const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2
          
          this.formItem.center.coordinates = [centerLng, centerLat]
        }
      }
    },
    
    // 获取地图中心点（改为方法而不是计算属性，避免返回函数）
    getMapCenter() {
      // 如果组件未初始化，返回默认值
      if (!this.initialized || !this.formItem) {
        return [116.397428, 39.90923] // 默认北京
      }
      
      try {
        if (this.formItem.center && 
            this.formItem.center.coordinates && 
            Array.isArray(this.formItem.center.coordinates) &&
            this.formItem.center.coordinates.length === 2) {
          const lng = this.formItem.center.coordinates[0]
          const lat = this.formItem.center.coordinates[1]
          
          // 检查是否为有效数字
          if (lng !== '' && lng !== null && lng !== undefined &&
              lat !== '' && lat !== null && lat !== undefined) {
            const lngNum = parseFloat(lng)
            const latNum = parseFloat(lat)
            
            // 验证是否为有效数字且在合理范围内
            if (!isNaN(lngNum) && !isNaN(latNum) &&
                lngNum >= -180 && lngNum <= 180 &&
                latNum >= -90 && latNum <= 90) {
              return [lngNum, latNum]
            }
          }
        }
      } catch (error) {
        console.warn('获取地图中心点失败:', error)
      }
      return [116.397428, 39.90923] // 默认北京
    },

    // 确认提交表单的函数
    ok(name) {
      this.$refs[name].validate((valid) => {
        // 使用表单验证
        if (!valid) return
        
        // 转换中心点坐标
        if (this.formItem.center && this.formItem.center.coordinates) {
          this.formItem.center.coordinates = this.formItem.center.coordinates.map(
            coord => coord === '' ? '' : parseFloat(coord)
          )
        }
        
        const postData = JSON.parse(JSON.stringify(this.formItem))
        
        // 确保边界数据格式正确
        if (postData.boundary && Array.isArray(postData.boundary) && postData.boundary.length > 0) {
          // 边界数据已经是数组格式，确保是有效的坐标数组
          let validBoundary = postData.boundary.filter(point => 
            Array.isArray(point) && 
            point.length >= 2 && 
            !isNaN(parseFloat(point[0])) && 
            !isNaN(parseFloat(point[1]))
          )
          
          // 去除重复的连续点
          if (validBoundary.length > 0) {
            const tolerance = 0.000001
            const deduplicatedBoundary = [validBoundary[0]]
            
            for (let i = 1; i < validBoundary.length; i++) {
              const current = validBoundary[i]
              const last = deduplicatedBoundary[deduplicatedBoundary.length - 1]
              
              // 检查当前点是否与上一个点重复
              const isDuplicate = Math.abs(current[0] - last[0]) < tolerance && 
                                 Math.abs(current[1] - last[1]) < tolerance
              
              if (!isDuplicate) {
                deduplicatedBoundary.push(current)
              }
            }
            
            validBoundary = deduplicatedBoundary
            console.log('去重后的边界点数:', validBoundary.length, '（原始:', postData.boundary.length, '）')
          }
          
          if (validBoundary.length >= 3) {
            // 确保边界闭合（如果最后一个点不等于第一个点，添加第一个点）
            const firstPoint = validBoundary[0]
            const lastPoint = validBoundary[validBoundary.length - 1]
            
            // 使用数值比较，考虑浮点数精度
            const tolerance = 0.000001
            const isClosed = Math.abs(firstPoint[0] - lastPoint[0]) < tolerance && 
                           Math.abs(firstPoint[1] - lastPoint[1]) < tolerance
            
            if (!isClosed) {
              postData.boundary = [...validBoundary, [firstPoint[0], firstPoint[1]]]
            } else {
              postData.boundary = validBoundary
            }
            console.log('提交边界数据:', postData.boundary.length, '个点')
          } else {
            console.warn('边界点数不足，至少需要3个点')
            // 如果边界点数不足，删除boundary字段
            delete postData.boundary
          }
        } else {
          // 如果没有边界或边界无效，删除boundary字段
          delete postData.boundary
        }
        
        // 检查是否需要提示用户：如果原有边界存在，但提交时没有边界，需要提示
        const hasOriginalBoundary = this.originalBoundary && 
                                    Array.isArray(this.originalBoundary) && 
                                    this.originalBoundary.length >= 3
        const hasNoBoundaryInPost = !postData.boundary || 
                                    !Array.isArray(postData.boundary) || 
                                    postData.boundary.length === 0
        
        if (this.formItem.areaId || this.formItem.area_id || this.formItem._id) {
          // 如果formItem中存在areaId或_id，表示是修改操作
          
          // 如果原有边界存在，但提交时没有边界，提示用户
          if (hasOriginalBoundary && hasNoBoundaryInPost) {
            this.$Modal.confirm({
              title: '提示',
              content: '<p>检测到该区域之前已设置边界，但本次提交没有包含边界数据。</p><p>提交后，系统将根据新的中心点生成默认边界，<strong style="color: #ff4d4f;">原有边界将失效</strong>。</p><p>是否继续提交？</p>',
              onOk: () => {
                // 用户确认后继续提交
                this.doSubmit(postData)
              },
              onCancel: () => {
                // 用户取消，不提交
                this.$Message.info('已取消提交')
              }
            })
            return
          }
          
          // 直接提交
          this.doSubmit(postData)
        } else {
          // 如果formItem中不存在areaId，表示是添加操作
          addArea(postData) // 调用addArea API添加区域
            .then((res) => {
              // 处理成功的响应
              if (res.data.code === 200) {
                // 如果响应码为200，表示添加成功
                this.$Message.success('区域添加成功') // 显示成功消息
                this.cancel('formItem') // 调用cancel函数重置表单和关闭模态框
                this.$emit('reload') // 触发reload事件，通知父组件重新加载数据
                // 重新获取区域列表并更新Vuex store，以便车辆管理界面能显示新区域
                this.updateAreaStore()
              } else {
                this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
              }
            })
            .catch((err) => {
              // 处理错误的响应
              this.$Message.error(err) // 显示错误消息
            })
        }
      })
    },
    
    // 执行提交操作（提取公共逻辑）
    doSubmit(postData) {
      if (this.formItem.areaId || this.formItem.area_id || this.formItem._id) {
        // 修改操作
        const updateData = {
          ...postData,
          area_id: this.formItem.area_id || this.formItem.areaId
        }
        console.log('提交更新数据:', JSON.stringify(updateData, null, 2))
        editArea(updateData) // 调用editArea API修改区域
          .then((res) => {
            // 处理成功的响应
            if (res.data.code === 200) {
              // 如果响应码为200，表示修改成功
              this.$Message.success('区域修改成功') // 显示成功消息
              this.cancel('formItem') // 调用cancel函数重置表单和关闭模态框
              this.$emit('reload') // 触发reload事件，通知父组件重新加载数据
              // 重新获取区域列表并更新Vuex store，以便车辆管理界面能显示新区域
              this.updateAreaStore()
            } else {
              this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
            }
          })
          .catch((err) => {
            // 处理错误的响应
            this.$Message.error(err) // 显示错误消息
          })
      }
    },

    // 取消操作并关闭模态框的函数
    cancel(name) {
      // 先关闭弹窗，避免因后续重置报错导致无法关闭
      this.open = false
      this.$nextTick(() => {
        this.originalBoundary = null
        this.formItem = {
          area_name: '',
          area_desc: '',
          phone: '',
          center: {
            type: 'Point',
            coordinates: ['', ''],
          },
          return_point: {
            type: 'Point',
            coordinates: ['', ''],
          },
          boundary: [],
        }
        this.activeTab = 'basic'
        this.initialized = false
        this.centerAddress = ''
        this.returnPointAddress = ''
        this.locationAddress = ''
        this.returnPointLocationAddress = ''
        this.addressSuggestions = []
        this.showSuggestions = false
        this.returnPointAddressSuggestions = []
        this.showReturnPointSuggestions = false
        this.destroyAutocomplete()
        if (this.$refs[name]) {
          this.$refs[name].resetFields()
        }
      })
    },
    
    // 初始化地址自动补全
    initAutocomplete() {
      if (!window.AMap || !window.AMap.Autocomplete) {
        console.warn('高德地图Autocomplete插件未加载')
        return
      }
      
      // 如果已存在实例，先销毁
      this.destroyAutocomplete()
      
      // 创建自动补全实例
      this.autocomplete = new window.AMap.Autocomplete({
        city: '', // 全国搜索
        citylimit: false, // 不限制城市
        input: this.$refs.addressInput ? this.$refs.addressInput.$el.querySelector('input') : null
      })
      
      // 监听选择事件
      this.autocomplete.on('select', (e) => {
        this.selectAddressFromAutocomplete(e)
      })
    },
    
    // 销毁自动补全实例
    destroyAutocomplete() {
      if (this.autocomplete) {
        try {
          // 检查是否有destroy方法
          if (typeof this.autocomplete.destroy === 'function') {
            this.autocomplete.destroy()
          } else if (typeof this.autocomplete.destroy === 'function') {
            // 某些版本的AMap可能方法名不同
            this.autocomplete.destroy()
          }
        } catch (e) {
          // 忽略销毁错误，不影响功能
          console.warn('销毁Autocomplete失败（可忽略）:', e)
        } finally {
          this.autocomplete = null
        }
      }
    },
    
    // 处理地址输入框获得焦点
    handleAddressFocus() {
      console.log('地址输入框获得焦点，当前值:', this.centerAddress)
      if (this.centerAddress && this.centerAddress.trim()) {
        this.showSuggestions = true
        this.searchAddressSuggestions(this.centerAddress)
      } else {
        this.showSuggestions = false
        this.addressSuggestions = []
      }
    },
    
    // 处理地址输入框失去焦点
    handleAddressBlur() {
      // 延迟隐藏，以便点击建议项时能触发
      setTimeout(() => {
        this.showSuggestions = false
      }, 200)
    },
    
    // 处理地址输入变化
    handleAddressChange(value) {
      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      
      // 处理value参数：可能是字符串、事件对象或undefined
      let keyword = ''
      if (typeof value === 'string') {
        keyword = value
      } else if (value && typeof value === 'object' && value.target) {
        // 如果是事件对象，从target.value获取
        keyword = value.target.value || ''
      } else {
        // 如果都不是，使用当前输入框的值
        keyword = this.centerAddress || ''
      }
      
      // 确保是字符串类型
      keyword = String(keyword || '')
      
      // 如果输入为空，清空建议列表
      if (!keyword || !keyword.trim()) {
        this.addressSuggestions = []
        this.showSuggestions = false
        return
      }
      
      // 防抖搜索
      this.searchTimer = setTimeout(() => {
        this.searchAddressSuggestions(keyword.trim())
      }, 300)
    },
    
    // 搜索地址建议（使用后端API）
    async searchAddressSuggestions(keyword) {
      if (!keyword || !keyword.trim()) {
        this.addressSuggestions = []
        this.showSuggestions = false
        return
      }
      
      const searchKeyword = keyword.trim()
      console.log('搜索地址关键词:', searchKeyword)
      
      // 显示加载状态
      this.geocoding = true
      this.showSuggestions = true
      
      try {
        // 调用后端API进行搜索
        const res = await searchPlace({ keyword: searchKeyword })
        
        this.geocoding = false
        
        if (res.data.code === 200 && res.data.data && res.data.data.length > 0) {
          this.addressSuggestions = res.data.data
          console.log('地址建议列表:', this.addressSuggestions)
          this.showSuggestions = true
        } else {
          console.warn('搜索失败或无结果:', res.data.msg, res.data.errorCode)
          
          // 如果是API Key类型错误，给出提示
          if (res.data.errorCode === 'USERKEY_PLAT_NOMATCH') {
            this.$Message.warning('API Key类型不匹配，请使用Web服务API类型的Key')
          }
          
          this.addressSuggestions = []
          this.showSuggestions = false
        }
      } catch (error) {
        this.geocoding = false
        console.error('地址搜索失败:', error)
        this.$Message.error('地址搜索失败，请稍候再试')
        this.addressSuggestions = []
        this.showSuggestions = false
      }
    },
    
    // 选择地址（从建议列表）
    selectAddress(item) {
      console.log('选择地址:', item)
      
      if (item && item.location) {
        const lng = item.location.lng
        const lat = item.location.lat
        
        // 更新地址输入框
        this.centerAddress = item.formattedAddress || item.name
        
        // 更新经纬度
        this.$set(this.formItem.center.coordinates, 0, lng.toFixed(6))
        this.$set(this.formItem.center.coordinates, 1, lat.toFixed(6))
        
        // 更新地址显示
        this.locationAddress = item.formattedAddress
        
        // 隐藏建议列表
        this.showSuggestions = false
        this.addressSuggestions = []
        this.geocoding = false
        
        this.$Message.success('地址选择成功')
      } else {
        console.warn('选择的地址项无效:', item)
        this.$Message.error('地址数据无效')
      }
    },
    
    // 从Autocomplete选择地址（备用方案）
    selectAddressFromAutocomplete(e) {
      if (e.poi && e.poi.location) {
        const lng = e.poi.location.lng
        const lat = e.poi.location.lat
        
        // 更新地址输入框
        this.centerAddress = e.poi.name + (e.poi.address || '')
        
        // 更新经纬度
        this.$set(this.formItem.center.coordinates, 0, lng.toFixed(6))
        this.$set(this.formItem.center.coordinates, 1, lat.toFixed(6))
        
        // 更新地址显示
        this.locationAddress = e.poi.name + (e.poi.address || '')
        
        this.$Message.success('地址选择成功')
      }
    },
    
    // 通过地址搜索获取经纬度（地理编码）
    async searchAddress() {
      if (!this.centerAddress || !this.centerAddress.trim()) {
        this.$Message.warning('请输入地址')
        return
      }
      
      this.geocoding = true
      
      try {
        // 调用后端API进行地理编码
        const res = await geocode({ address: this.centerAddress })
        
        this.geocoding = false
        
        if (res.data.code === 200 && res.data.data && res.data.data.location) {
          const { location } = res.data.data
          
          // 更新经纬度
          this.$set(this.formItem.center.coordinates, 0, location.lng.toFixed(6))
          this.$set(this.formItem.center.coordinates, 1, location.lat.toFixed(6))
          
          // 更新地址显示
          this.locationAddress = res.data.data.formattedAddress || this.centerAddress
          
          this.$Message.success('地址解析成功')
        } else {
          this.$Message.error(res.data.msg || '未找到该地址，请检查地址是否正确')
        }
      } catch (error) {
        this.geocoding = false
        console.error('地址解析失败:', error)
        this.$Message.error('地址解析失败，请稍候再试')
      }
    },
    
    // 通过经纬度反查地址（逆地理编码）
    async reverseGeocode() {
      const lng = this.formItem.center.coordinates[0]
      const lat = this.formItem.center.coordinates[1]
      
      // 检查经纬度是否有效
      if (!lng || !lat || lng === '' || lat === '') {
        this.locationAddress = ''
        this.centerAddress = ''
        return
      }
      
      const lngNum = parseFloat(lng)
      const latNum = parseFloat(lat)
      
      if (isNaN(lngNum) || isNaN(latNum)) {
        this.locationAddress = ''
        this.centerAddress = ''
        return
      }
      
      try {
        // 调用后端API进行逆地理编码
        const res = await regeocode({ lng: lngNum, lat: latNum })
        
        if (res.data.code === 200 && res.data.data && res.data.data.formattedAddress) {
          const address = res.data.data.formattedAddress
          this.locationAddress = address
          // 如果地址输入框为空，自动填充
          if (!this.centerAddress || this.centerAddress.trim() === '') {
            this.centerAddress = address
          }
        } else {
          this.locationAddress = ''
        }
      } catch (error) {
        console.error('逆地理编码失败:', error)
        this.locationAddress = ''
      }
    },
    
    // 从坐标加载地址（用于编辑时显示已有地址）
    async loadAddressFromCoordinates(coordinates) {
      if (!coordinates || !Array.isArray(coordinates) || coordinates.length < 2) {
        return
      }
      
      const lng = parseFloat(coordinates[0])
      const lat = parseFloat(coordinates[1])
      
      if (isNaN(lng) || isNaN(lat)) {
        return
      }
      
      try {
        // 调用后端API进行逆地理编码
        const res = await regeocode({ lng: lng, lat: lat })
        
        if (res.data.code === 200 && res.data.data && res.data.data.formattedAddress) {
          const address = res.data.data.formattedAddress
          // 设置地址输入框和显示地址
          this.centerAddress = address
          this.locationAddress = address
          console.log('已加载地址:', address)
        }
      } catch (error) {
        console.error('加载地址失败:', error)
      }
    },
    
    // 更新Vuex store中的区域列表
    async updateAreaStore() {
      try {
        const res = await getAreaListByRole()
        if (res.data.code === 200) {
          // 更新Vuex store中的区域数据
          this.$store.commit('setareas', JSON.stringify(res.data.data))
          console.log('区域列表已更新到Vuex store')
        } else {
          console.error('获取区域列表失败:', res.data.msg)
        }
      } catch (error) {
        console.error('更新区域列表失败:', error)
      }
    },
    
    // ========== 还车点相关方法 ==========
    // 还车点地址输入框获得焦点
    handleReturnPointAddressFocus() {
      console.log('还车点地址输入框获得焦点，当前值:', this.returnPointAddress)
      if (this.returnPointAddress && this.returnPointAddress.trim()) {
        this.showReturnPointSuggestions = true
        this.searchReturnPointAddressSuggestions(this.returnPointAddress)
      } else {
        this.showReturnPointSuggestions = false
      }
    },
    
    // 还车点地址输入框失去焦点
    handleReturnPointAddressBlur() {
      // 延迟隐藏，让点击事件先执行
      setTimeout(() => {
        this.showReturnPointSuggestions = false
      }, 200)
    },
    
    // 还车点地址输入变化
    handleReturnPointAddressChange(value) {
      // 清除之前的定时器
      if (this.returnPointSearchTimer) {
        clearTimeout(this.returnPointSearchTimer)
      }
      
      // 处理value参数：可能是字符串、事件对象或undefined
      let keyword = ''
      if (typeof value === 'string') {
        keyword = value
      } else if (value && typeof value === 'object' && value.target) {
        // 如果是事件对象，从target.value获取
        keyword = value.target.value || ''
      } else {
        // 如果都不是，使用当前输入框的值
        keyword = this.returnPointAddress || ''
      }
      
      // 确保是字符串类型
      keyword = String(keyword || '')
      
      // 如果输入为空，清空建议列表
      if (!keyword || !keyword.trim()) {
        this.returnPointAddressSuggestions = []
        this.showReturnPointSuggestions = false
        return
      }
      
      // 防抖搜索
      this.returnPointSearchTimer = setTimeout(() => {
        this.searchReturnPointAddressSuggestions(keyword.trim())
      }, 300)
    },
    
    // 搜索还车点地址建议
    async searchReturnPointAddressSuggestions(keyword) {
      if (!keyword || !keyword.trim()) {
        this.returnPointAddressSuggestions = []
        this.showReturnPointSuggestions = false
        return
      }
      
      const searchKeyword = keyword.trim()
      console.log('搜索还车点地址关键词:', searchKeyword)
      
      // 显示加载状态
      this.returnPointGeocoding = true
      this.showReturnPointSuggestions = true
      
      try {
        // 调用后端API进行搜索
        const res = await searchPlace({ keyword: searchKeyword })
        
        this.returnPointGeocoding = false
        
        if (res.data.code === 200 && res.data.data && res.data.data.length > 0) {
          this.returnPointAddressSuggestions = res.data.data
          console.log('还车点地址建议列表:', this.returnPointAddressSuggestions)
          this.showReturnPointSuggestions = true
        } else {
          console.warn('搜索还车点地址失败或无结果:', res.data.msg, res.data.errorCode)
          
          // 如果是API Key类型错误，给出提示
          if (res.data.errorCode === 'USERKEY_PLAT_NOMATCH') {
            this.$Message.warning('API Key类型不匹配，请使用Web服务API类型的Key')
          }
          
          this.returnPointAddressSuggestions = []
          this.showReturnPointSuggestions = false
        }
      } catch (error) {
        this.returnPointGeocoding = false
        console.error('还车点地址搜索失败:', error)
        this.$Message.error('还车点地址搜索失败，请稍候再试')
        this.returnPointAddressSuggestions = []
        this.showReturnPointSuggestions = false
      }
    },
    
    // 选择还车点地址
    selectReturnPointAddress(item) {
      console.log('选择还车点地址:', item)
      
      if (item && item.location) {
        const lng = item.location.lng
        const lat = item.location.lat
        
        // 更新地址输入框
        this.returnPointAddress = item.formattedAddress || item.name
        
        // 更新经纬度
        this.$set(this.formItem.return_point.coordinates, 0, lng.toFixed(6))
        this.$set(this.formItem.return_point.coordinates, 1, lat.toFixed(6))
        
        // 更新地址显示
        this.returnPointLocationAddress = item.formattedAddress
        
        // 隐藏建议列表
        this.showReturnPointSuggestions = false
        this.returnPointAddressSuggestions = []
        this.returnPointGeocoding = false
        
        this.$Message.success('还车点地址选择成功')
      } else {
        console.warn('选择的还车点地址项无效:', item)
        this.$Message.error('还车点地址数据无效')
      }
    },
    
    // 通过还车点经纬度反查地址（逆地理编码）
    async reverseGeocodeReturnPoint() {
      const lng = this.formItem.return_point.coordinates[0]
      const lat = this.formItem.return_point.coordinates[1]
      
      // 检查经纬度是否有效
      if (!lng || !lat || lng === '' || lat === '') {
        this.returnPointLocationAddress = ''
        this.returnPointAddress = ''
        return
      }
      
      const lngNum = parseFloat(lng)
      const latNum = parseFloat(lat)
      
      if (isNaN(lngNum) || isNaN(latNum)) {
        this.returnPointLocationAddress = ''
        this.returnPointAddress = ''
        return
      }
      
      try {
        // 调用后端API进行逆地理编码
        const res = await regeocode({ lng: lngNum, lat: latNum })
        
        if (res.data.code === 200 && res.data.data && res.data.data.formattedAddress) {
          const address = res.data.data.formattedAddress
          this.returnPointLocationAddress = address
          // 如果地址输入框为空，自动填充
          if (!this.returnPointAddress || this.returnPointAddress.trim() === '') {
            this.returnPointAddress = address
          }
        } else {
          this.returnPointLocationAddress = ''
        }
      } catch (error) {
        console.error('还车点逆地理编码失败:', error)
        this.returnPointLocationAddress = ''
      }
    },
    
    // 从坐标加载还车点地址（用于编辑时显示已有地址）
    async loadReturnPointAddressFromCoordinates(coordinates) {
      if (!coordinates || !Array.isArray(coordinates) || coordinates.length < 2) {
        return
      }
      
      const lng = parseFloat(coordinates[0])
      const lat = parseFloat(coordinates[1])
      
      if (isNaN(lng) || isNaN(lat)) {
        return
      }
      
      try {
        // 调用后端API进行逆地理编码
        const res = await regeocode({ lng: lng, lat: lat })
        
        if (res.data.code === 200 && res.data.data && res.data.data.formattedAddress) {
          const address = res.data.data.formattedAddress
          // 设置地址输入框和显示地址
          this.returnPointAddress = address
          this.returnPointLocationAddress = address
          console.log('已加载还车点地址:', address)
        }
      } catch (error) {
        console.error('加载还车点地址失败:', error)
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
    }
    if (this.returnPointSearchTimer) {
      clearTimeout(this.returnPointSearchTimer)
    }
    // 销毁自动补全实例
    this.destroyAutocomplete()
  }
}
</script>

<style lang="less" scoped>
.address-input-wrapper {
  position: relative;
  width: 100%;
  
  .address-suggestions {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    max-height: 300px;
    overflow-y: auto;
    margin-top: 4px;
    
    .suggestion-item {
      padding: 12px 16px;
      cursor: pointer;
      display: flex;
      align-items: flex-start;
      transition: background-color 0.2s;
      border-bottom: 1px solid #f0f0f0;
      
      &:last-child {
        border-bottom: none;
      }
      
      &:hover,
      &.hovered {
        background-color: #f5f5f5;
      }
      
      .suggestion-content {
        flex: 1;
        
        .suggestion-name {
          font-size: 14px;
          color: #333;
          font-weight: 500;
          margin-bottom: 4px;
        }
        
        .suggestion-address {
          font-size: 12px;
          color: #999;
        }
      }
    }
  }
}
</style>
